<template>
    <section v-if="isVisibleOnSmallScreens" class="hero is-fullheight">
        <div class="hero-body">
            <div class="container">
                <div class="columns">
                    <div class="column is-4 is-offset-4">
                        <!-- <p class="has-text-centered"><img src="/public/img/logo.png" style="max-width: 100%"></p> -->
                        <p class="has-text-centered logo mb">Ordino</p>

                        <form @submit.prevent="handleForgotPassword">
                            <o-field label="Email" :type="fieldType('email')" :message="getError('email')">
                                <o-input placeholder="email@example.com" v-model="form.email" autofocus></o-input>
                            </o-field>

                            <button class="button is-primary is-miedum is-pulled-right" v-submit="submitting">
                                <span class="icon">
                                  <i class="fa fa-paper-plane"></i>
                                </span>
                                <span>Send</span>
                            </button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import {mapActions} from 'vuex'
    import HandlesForm from '../mixins/HandlesForm'
    import SmallScreensConfirmationMixin from '../mixins/SmallScreensConfirmation.js'

    export default {
        mixins: [SmallScreensConfirmationMixin, HandlesForm],

        data() {
            return {
                form: {email: ''}
            }
        },

        methods: {
            ...mapActions(['forgotPassword']),

            handleForgotPassword () {
                let submit = this.wrapSubmit(this.forgotPassword)
                submit(this.form).then(response => {
                    this.$swal.fire({
                        text: 'Reset password link has been sent to you email',
                        icon: 'success'
                    })
                })
            }
        }
    }
</script>
